import * as React from "react";
import { Typeahead } from "react-bootstrap-typeahead";

import { SuggestList } from "../../../../SuggestList/SuggestList";
import { ActionType } from "../flux";
import { TypeaheadEnterEscWrapper } from "../../../../TypeaheadEnterEscWrapper";

interface Props
{
    className?: string;
    
    options: string[];
    selectedTags: string[];
    suggestions: string[];
    onChange: (tags: string[]) => void;
}

export class RemoveTagsGroupAction extends React.Component<Props, any>
{
    public static defaultProps = {
        type: ActionType.RemoveTags
    };

    render()
    {
        const { className, options, selectedTags, suggestions, onChange } = this.props;
        return (
            <div className={className}>
                <TypeaheadEnterEscWrapper>
                    <Typeahead key="remove-tags" multiple
                        placeholder="Enter a tag"
                        selected={selectedTags}
                        options={options}
                        onChange={onChange}
                    />
                </TypeaheadEnterEscWrapper>
                <SuggestList items={suggestions} onClick={(tag, idx) => onChange([...selectedTags, tag])} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Vehicle/BatchEdit/GroupActions/RemoveTagsGroupAction.tsx